function Shapes({ size }: { size: number }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            {/* Circle */}
            <circle cx="7" cy="7" r="5" fill="none" stroke="currentColor" strokeWidth="1.5" />
            {/* Rectangle */}
            <rect x="12" y="12" width="10" height="10" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5" />
            {/* Triangle */}
            <polygon points="4,22 10,12 16,22" fill="none" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    )
}

export default Shapes
